module.exports = __webpack_public_path__ + "img/visa.87c6da5f.svg";